import React from 'react';
import { Typography } from 'antd';
import AlumlyBreadCrumb, { PathT } from '../../../components/AlumlyBreadCrumb';
import { RouteNameEnum } from '../../../enums/routeName';
import FormNews from '../components/FormNews';

const CreateNews: React.FC = () => {
  const path: PathT[] = [
    { label: 'News', value: RouteNameEnum.news.index },
    { label: 'Create news' },
  ];

  return (
    <div>
      <AlumlyBreadCrumb path={path} />
      <Typography.Title level={4} style={{ fontWeight: 'bold' }}>Create News</Typography.Title>
      <FormNews mode="create" />
    </div>
  );
};

export default CreateNews;
